import _ from 'lodash'
import sumItems from '../../../../../lib/calculations/sumItems'

export default (form, field, baseName, isItem) => (e) => {
  field.onChange(e)

  if (!isItem) return

  const {
    setFieldValue
  } = form

  const parentBaseName = baseName.split('.')[0]
  const values = _.cloneDeep(form.values)
  _.set(values, e.target.name, e.target.value)

  setFieldValue(`${parentBaseName}.value`, sumItems({ values }, parentBaseName))
}
